/**
 * Serviço para buscar endereço por CEP usando a API ViaCEP
 * API gratuita: https://viacep.com.br/
 */

/**
 * Busca informações de endereço pelo CEP
 * @param {string} cep - CEP no formato "12345678" ou "12345-678"
 * @returns {Promise<{ok: boolean, data?: object, error?: string}>}
 */
export async function buscarCEP(cep) {
    // Remove caracteres não numéricos
    const cepLimpo = cep.replace(/\D/g, "");

    // Valida se tem 8 dígitos
    if (cepLimpo.length !== 8) {
        return { ok: false, error: "CEP deve conter 8 dígitos" };
    }

    try {
        const response = await fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`);

        if (!response.ok) {
            return { ok: false, error: "Erro ao buscar CEP" };
        }

        const data = await response.json();

        // ViaCEP retorna {erro: true} quando o CEP não é encontrado
        if (data.erro) {
            return { ok: false, error: "CEP não encontrado" };
        }

        return {
            ok: true,
            data: {
                cep: data.cep || cepLimpo,
                street: data.logradouro || "",
                district: data.bairro || "",
                city: data.localidade || "",
                state: data.uf || "",
                complement: data.complemento || "",
            },
        };
    } catch (error) {
        console.error("Erro ao buscar CEP:", error);
        return { ok: false, error: "Erro ao conectar com o serviço de CEP" };
    }
}
